import styled from 'styled-components'

import { Checklist, OrderIssueButton, Customer, Order, OtherOrder, Slip } from './Info'
import Colors from '../../../constants/Colors'

const Detail = ({
  status,
  order,
  slips,
  remainingAmount,
  otherOrders,
  setSlips,
  setOrders,
  setRemainingAmount,
  fetchOrdersByStatus,
  fetchOrderAferUpdateStatus,
}) => {
  return (
    <Container>
      <Header>
        <span>คำสั่งซื้อ #{order.orderId}</span>
        {order.status === 'CONFIRMED' && status !== 'ISSUE' && (
          <OrderIssueButton order={order} fetchOrdersByStatus={fetchOrdersByStatus} />
        )}
      </Header>
      <span>
        <Customer userInfo={order?.userInfo} />
        <Order order={order} slips={slips} />
        <Checklist
          order={order}
          slips={slips}
          remainingAmount={remainingAmount}
          setOrders={setOrders}
          status={status}
          fetchOrderAferUpdateStatus={fetchOrderAferUpdateStatus}
        />
        <Slip
          order={order}
          slips={slips}
          setSlips={setSlips}
          setOrders={setOrders}
          setRemainingAmount={setRemainingAmount}
          fetchOrdersByStatus={fetchOrdersByStatus}
        />
        <OtherOrder otherOrders={otherOrders} />
      </span>
    </Container>
  )
}

export default Detail

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 10px;
  border-radius: 20px;
  background-color: ${Colors.WHITE};
`
const Header = styled.h3`
  font-weight: bold;
  display: flex;
  justify-content: space-between;
`
